import { requester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import btnSound from "resources/music/button-pressed-38129.mp3";
import categorySound from "resources/music/물방울.mp3";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import HorizontalMenuButtons from "../../process/Button/HorizontalMenuButtons";
import HorizontalBrandList from "../../process/brand/HorizontalBrandList";
import SlideGuide from "../process/SlideGuide";
import DemoHorizontalProductListView from "./DemoHorizontalProductListView";




function DemoHorizontalMainView2(props) {
    const { id } = useParams();
    const { viewData, setViewData, rankedProducts, showButtons, currentPage, setCurrentPage, setShowButtons, products, filteredProducts, setFilteredProducts, selectedCategory, setSelectedCategory, currentProductIndex, setCurrentProductIndex } = props;
    const navigate = useNavigate();
    const audioRef = useRef();
    const audio1Ref = useRef();
    const { isMobile } = useContext(BrowserDetectContext);
    const itemsPerPage = 10;
    const skeletonCount = 10;
    // const [currentPage, setCurrentPage] = useState(1);
    const [currentBrandPage, setCurrentBrandPage] = useState(1);
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState(brands);
    const [showBrandProducts, setShowBrandProducts] = useState(false);
    const [showExhibition, setShowExhibition] = useState(false);
    const [brandVisible, setBrandVisible] = useState(false);
    const { isLoading, isBrandLoading } = useSelector((state) => ({
        isLoading: state.history.isLoading,
        isBrandLoading: state.history.isBrandLoading
    }));

    const skeletonItems = Array.from({ length: 10 }, (_, index) => ({
        type: 'skeleton',
        key: `skeleton-${index}`
    }));

    const totalProducts = filteredProducts.length;
    const totalPages = Math.ceil(totalProducts / itemsPerPage);
    // const totalBrandPages = Math.ceil(brands.length / brandsItemsPerPage);

    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);

    const brandTypeMap = {
        DISPOSABLEDEVICE: '일회용',
        DEVICE: '기기',
        LIQUID: '액상',
        // 더 추가할 수 있음
        null: '기타',  // brandType이 null인 경우 처리
    };
    const uniqueBrandTypes = [...new Set(brands.map(brand => brand.brandType))].filter(type => type !== null);
    const productCategories = uniqueBrandTypes.map(type => brandTypeMap[type] || type);



    // const onEventClick = () => {
    //     audioRef.current.play();
    //     dispatch(HistoryReducer.actions.setLoading(true));
    //     let data = { storeCode: id }
    //     requester.findEventProductsByStoreId(data, (result) => {
    //         if (result.code === 0) {
    //             const eventProducts = result.data;
    //             const eventProductIds = rankedProducts.map(product => product.id);
    //             const filteredProducts = eventProducts.filter(product => !eventProductIds.includes(product.id));

    //             const addProducts = [...rankedProducts, ...filteredProducts];
    //             dispatch(HistoryReducer.actions.setLoading(false));
    //             setFilteredProducts(addProducts);
    //             setViewData((prevData) => ({
    //                 ...prevData,
    //                 view: "eventsProducts"
    //             }));

    //         } else {

    //         }
    //         setShowButtons(false);
    //         setShowExhibition(false);
    //     });
    //     setBrands([])
    //     setCurrentPage(1)
    // }

    const onEventClick = () => {
        audioRef.current.play();
        dispatch(HistoryReducer.actions.setLoading(true));

        // 초기에 skeleton 아이템으로 설정
        setFilteredProducts(skeletonItems);

        let data = { storeCode: id }
        requester.findEventProductsByStoreId(data, (result) => {
            if (result.code === 0) {
                const eventProducts = result.data;
                const eventProductIds = rankedProducts.map(product => product.id);
                const filteredProducts = eventProducts.filter(product => !eventProductIds.includes(product.id));

                const addProducts = [...rankedProducts, ...filteredProducts];
                dispatch(HistoryReducer.actions.setLoading(false));
                setFilteredProducts(addProducts);
                setViewData((prevData) => ({
                    ...prevData,
                    view: "eventsProducts"
                }));
            } else {
                // 에러 발생 시 빈 배열로 설정
                setFilteredProducts([]);
            }
            setShowButtons(false);
            setShowExhibition(false);
        });
        setBrands([])
        setCurrentPage(1)
    }

    // const onBestClick = () => {
    //     audioRef.current.play();
    //     dispatch(HistoryReducer.actions.setLoading(true));
    //     let data = { storeCode: id }
    //     requester.getBestProducts(data, (result) => {
    //         if (result.code === 0) {
    //             const bestProducts = result.data;
    //             const bestProductIds = rankedProducts.map(product => product.id);
    //             const filteredProducts = bestProducts.filter(product => !bestProductIds.includes(product.id));

    //             const addProducts = [...rankedProducts, ...filteredProducts];
    //             dispatch(HistoryReducer.actions.setLoading(false));
    //             setFilteredProducts(addProducts);
    //             setViewData((prevData) => ({
    //                 ...prevData,
    //                 view: "bestProducts"
    //             }));
    //         } else {

    //         }
    //         setShowButtons(false);
    //         setShowExhibition(false);
    //     });
    //     setBrands([])
    //     setCurrentPage(1)
    // }
    const onBestClick = () => {
        audioRef.current.play();
        dispatch(HistoryReducer.actions.setLoading(true));

        // 초기에 skeleton 아이템으로 설정
        setFilteredProducts(skeletonItems);

        let data = { storeCode: id }
        requester.getBestProducts(data, (result) => {
            if (result.code === 0) {
                const bestProducts = result.data;
                const bestProductIds = rankedProducts.map(product => product.id);
                const filteredProducts = bestProducts.filter(product => !bestProductIds.includes(product.id));

                const addProducts = [...rankedProducts, ...filteredProducts];
                dispatch(HistoryReducer.actions.setLoading(false));
                setFilteredProducts(addProducts);
                setViewData((prevData) => ({
                    ...prevData,
                    view: "bestProducts"
                }));
            } else {
                // 에러 발생 시 빈 배열로 설정
                setFilteredProducts([]);
            }
            setShowButtons(false);
            setShowExhibition(false);
        });
        setBrands([])
        setCurrentPage(1)
    }

    const onBrandClick = () => {
        dispatch(HistoryReducer.actions.setBrandLoading(true));
        audioRef.current.play();
        let data = { storeCode: id }
        requester.findBrandsByStoreCode(data, (result) => {
            if (result.data) {
                setBrands(result.data);
                setFilteredBrands(result.data);
                setFilteredProducts([]);
                setViewData((prevData) => ({
                    ...prevData,
                    view: "brandList"
                }));
            } else {
                // 오류 처리
            }
            dispatch(HistoryReducer.actions.setBrandLoading(false));
        });
        setShowButtons(false);
        setShowBrandProducts(true);
    };

    const onNewClick = () => {
        audioRef.current.play();
        dispatch(HistoryReducer.actions.setLoading(true));

        // 초기에 skeleton 아이템으로 설정
        setFilteredProducts(skeletonItems);

        let data = { storeCode: id }
        requester.findNewProductsByStoreId(data, (result) => {
            console.log("result", result);
            if (result.code === 0) {
                const newProducts = result.data;
                const newProductIds = rankedProducts.map(product => product.id);
                const filteredProducts = newProducts.filter(product => !newProductIds.includes(product.id));
                const addProducts = [...rankedProducts, ...filteredProducts];
                console.log("addProducts", addProducts);
                dispatch(HistoryReducer.actions.setLoading(false));
                setFilteredProducts(addProducts);
                setViewData((prevData) => ({
                    ...prevData,
                    view: "newProducts"
                }));
            } else {
                // 에러 발생 시 빈 배열로 설정
                setFilteredProducts([]);
            }
            setShowButtons(false);
            setShowExhibition(false);
        });
        setBrands([])
        setCurrentPage(1)
    }



    const onExhibitionClick = () => {
        setShowButtons(false);
        setShowExhibition(true);
        setShowBrandProducts(false);
    }

    // const onAdClick = () => {
    //     audioRef.current.play();
    //     let brandData = {
    //         storeCode: id,
    //         brandId: "c836e67e-8f92-474c-88e8-39240974378a"
    //     }
    //     dispatch(HistoryReducer.actions.setLoading(true));
    //     setShowButtons(false)
    //     setBrandVisible(true)
    //     requester.findAllProductsByBrand(brandData, (result) => {
    //         setFilteredProducts(result.data)
    //         dispatch(HistoryReducer.actions.setLoading(false));
    //         setBrands([]);
    //         setShowBrandProducts(false)
    //         setViewData((prevData) => ({
    //             ...prevData,
    //             view: "adProducts"
    //         }));
    //     })
    //     setCurrentPage(1)
    // }

    const onAdClick = () => {
        audioRef.current.play();
        let brandData = {
            storeCode: id,
            brandId: "c836e67e-8f92-474c-88e8-39240974378a"
        }
        dispatch(HistoryReducer.actions.setLoading(true));

        // 초기에 skeleton 아이템으로 설정
        setFilteredProducts(skeletonItems);

        setShowButtons(false)
        setBrandVisible(true)
        requester.findAllProductsByBrand(brandData, (result) => {
            setFilteredProducts(result.data)
            dispatch(HistoryReducer.actions.setLoading(false));
            setBrands([]);
            setShowBrandProducts(false)
            setViewData((prevData) => ({
                ...prevData,
                view: "adProducts"
            }));
        })
        setCurrentPage(1)
    }

    const onGoBackBtnClick = () => {
        audioRef.current.play();
        let data = { storeCode: id }
        if (selectedCategory === 'main') {
            if (viewData.view === "BrandProductList") {
                setBrandVisible(false)
                requester.findBrandsByStoreCode(data, (result) => {
                    setShowBrandProducts(true);
                    setBrands(result.data);
                    setFilteredBrands(result.data)
                    setViewData((prevData) => ({
                        ...prevData,
                        view: "brandList",
                    }));
                })
                setCurrentPage(1)
                setViewData((prevData) => ({
                    ...prevData,
                    currentBrandPage: null
                }));

            } else if (viewData.view === "brandList") {
                setBrands([]);
                setShowButtons(true);
                setViewData((prevData) => ({
                    ...prevData,
                    view: "main",
                }));
                setCurrentPage(1)
                setCurrentBrandPage(1)
            } else {
                setShowButtons(true);
                setViewData((prevData) => ({
                    ...prevData,
                    view: null,
                }));
                setCurrentPage(1)
            }
        } else {
            requester.findBrandsByStoreCode(data, (result) => {
                setShowBrandProducts(true);
                setBrands(result.data);
                setFilteredBrands(result.data)
            })
            setCurrentPage(1)
        }

    }

    useEffect(() => {
        if (brands.length === 0 && viewData.view === "brandList") {
            let data = { storeCode: id }
            requester.findBrandsByStoreCode(data, (result) => {
                setShowBrandProducts(true);
                setBrands(result.data);
                setFilteredBrands(result.data)
                setViewData((prevData) => ({
                    ...prevData,
                    view: "brandList"
                }));

            })

        }

    }, [brands]);

    useEffect(() => {
        if (totalPages === 0 && currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [totalPages, currentPage]);



    useEffect(() => {
        if ((viewData.view === "brandList" && brands.length > 0) || (!viewData.view === "brandList" && filteredProducts.length > 0)) {
            const timer = setTimeout(() => {
                setViewData((prevData) => ({
                    ...prevData,
                    slideGuide: false
                }));
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [showBrandProducts, brands, filteredProducts]);

    return (
        <div style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex", alignItems: "center" }}>
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <audio ref={audio1Ref} src={btnSound} preload="auto" />
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {brands.length > 0 && viewData.slideGuide &&
                    <div style={{ position: "absolute", top: "40%", left: "40%", width: "max-content", zIndex: 999 }}>
                        <SlideGuide setViewData={setViewData} />
                    </div>
                }
                {viewData.slideGuide && filteredProducts.length > 0 &&
                    <div style={{ position: "absolute", top: "40%", left: "40%", width: "max-content", zIndex: 999 }}>
                        <SlideGuide setViewData={setViewData} />
                    </div>
                }
                {
                    (viewData.view === null || viewData.view === undefined || viewData.view === 'main') && (viewData.view !== "adProducts" || viewData.view !== "bestProducts" || viewData.view !== "eventsProducts" || viewData.view !== "BrandProductList" || viewData.view !== "brandList") ?
                        <HorizontalMenuButtons
                            onBrandClick={onBrandClick}
                            onAdClick={onAdClick}
                            onEventClick={onEventClick}
                            onBestClick={onBestClick}
                            onNewClick={onNewClick}
                        />
                        : viewData.view === "brandList" ? (
                            <HorizontalBrandList
                                brands={brands}
                                setBrands={setBrands}
                                filteredBrands={filteredBrands}
                                setFilteredBrands={setFilteredBrands}
                                brandVisible={brandVisible}
                                setShowExhibition={setShowExhibition}
                                setBrandVisible={setBrandVisible}
                                setShowBrandProducts={setShowBrandProducts}
                                setFilteredProducts={setFilteredProducts}
                                setViewData={setViewData}
                                currentBrandPage={currentBrandPage}
                                setCurrentBrandPage={setCurrentBrandPage}
                                onGoBackBtnClick={onGoBackBtnClick}
                            />
                        )
                            :
                            (viewData.view === "adProducts" || viewData.view === "bestProducts" || viewData.view === "eventsProducts" || viewData.view === "BrandProductList" || viewData.view === "newProducts" || viewData.view === "detail") ?
                                <DemoHorizontalProductListView
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    filteredProducts={filteredProducts}
                                    setViewData={setViewData}
                                    onGoBackBtnClick={onGoBackBtnClick}
                                    currentProductIndex={currentProductIndex}
                                    setCurrentProductIndex={setCurrentProductIndex}
                                    isLoading={isLoading}
                                />
                                :
                                <p>상품을 불러오는 중 오류가 발생했습니다.</p>
                }
            </div>
        </div>
    );
}

export default DemoHorizontalMainView2;